export default __webpack_public_path__ + "static/media/gallery10.b932d7b5.jpg";